import TrendingHome from './TrendingHome';

export default TrendingHome;
